import { createStore } from './createStore';
export var store = createStore();
export var getStoreInstance = function getStoreInstance() {
  return store;
};